import { render, staticRenderFns } from "./AdvisoryPackages.vue?vue&type=template&id=79e6fd5e&scoped=true"
import script from "./AdvisoryPackages.vue?vue&type=script&lang=js"
export * from "./AdvisoryPackages.vue?vue&type=script&lang=js"
import style0 from "./AdvisoryPackages.vue?vue&type=style&index=0&id=79e6fd5e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79e6fd5e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VRow})
